import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Avatar from "@mui/material/Avatar";
// Limitless imports
import { useExpertProfileContext } from "@limitless/expert";
import { modernLogoLight } from "@limitless/images";

const useStyles = makeStyles(theme => ({
    Icon: {
        width: 21,
        height: 21,
        backgroundColor: theme.palette.background.white
    }
}));

const ModernTenantAvatar = ({ tenantName, style, url = "" }) => {
    const classes = useStyles();

    const { profileTenantsBrandAsset } = useExpertProfileContext();

    const tenantAssetUrl = React.useMemo(() => {
        return (
            profileTenantsBrandAsset.filter(item => item.tenantName === tenantName)[0]?.brandAssetUrl || modernLogoLight
        );
    }, [profileTenantsBrandAsset]);

    return <Avatar className={style ? style : classes.Icon} src={url ? url : tenantAssetUrl} />;
};

export default ModernTenantAvatar;

ModernTenantAvatar.propTypes = {
    tenantName: PropTypes.string.isRequired,
    style: PropTypes.object,
    url: PropTypes.string
};
